import { Mui } from "@osu/react-ui";

const cardActionsSx = (theme) => {
  return {
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column-reverse",
      [`&.${Mui.cardActionsClasses.root} button.${Mui.buttonClasses.root}`]: {
        marginLeft: 0,
        marginRight: 0,
        marginTop: 1,
      },
      [`&.${Mui.cardActionsClasses.root} button.${Mui.buttonClasses.contained}`]:
        {
          width: "100%",
        },
    },
    [theme.breakpoints.up("sm")]: {
      justifyContent: "space-between",
    },
  };
};

const autocompleteGroupSx = (theme) => ({
  display: "flex",
  flexDirection: "row",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    "& > button": {
      marginTop: 1,
    },
  },
  [theme.breakpoints.up("sm")]: {
    "& > button": {
      marginLeft: 1,
    },
  },
});

export { cardActionsSx, autocompleteGroupSx };
